import { Injectable, inject } from '@angular/core'
import { GbErrorMessageService } from '@galabid/shared/utils/helpers'
import { GbLoaderService } from '@galabid/shared/utils/loader'
import { GbNotificationService } from '@galabid/shared/utils/notification'
import { Actions, createEffect, ofType } from '@ngrx/effects'
import { catchError, exhaustMap, finalize, map, switchMap, tap, withLatestFrom } from 'rxjs'
import { CustomerPaymentMethodsApiService } from './customer-payment-methods-api.service'
import * as CustomerPaymentMethodsActions from './customer-payment-methods.actions'
import { CUSTOMER_PAYMENT_METHODS_LOADER } from './customer-payment-methods.models'
import { GbCustomerPaymentMethodsDialogComponent } from 'libs/gb-dashboard/checkout/feature/src/lib/gb-customer-payment-methods-dialog/gb-customer-payment-methods-dialog.component'
import { GbDashboardDialogService } from '@galabid/gb-dashboard/shared/utils'
import { SelectedAuctionFacade } from 'libs/gb-dashboard/auctions/data-access-selected-auction/src/lib/+state/selected-auction.facade'

@Injectable()
export class CustomerPaymentMethodsEffects {
  private actions$ = inject(Actions)

  loadCustomerPaymentMethods$ = createEffect(() =>
    this.actions$.pipe(
      ofType(CustomerPaymentMethodsActions.loadCustomerPaymentMethods),
      withLatestFrom(this.selectedAuctionFacade.urlName$),
      tap(() => this.gbLoaderService.showLoaderDialog(CUSTOMER_PAYMENT_METHODS_LOADER.loadCustomerPaymentMethods.id)),
      switchMap(([action, urlName]) =>
        this.customerPaymentMethodsApiService.getPaymentMethods(urlName, action.stripeCustomerUuid).pipe(
          map((response) =>
            CustomerPaymentMethodsActions.loadCustomerPaymentMethodsSuccess({
              customerPaymentMethods: response.payment_methods,
            }),
          ),
          catchError(async (error) =>
            CustomerPaymentMethodsActions.loadCustomerPaymentMethodsFailure({
              error,
            }),
          ),
          finalize(() =>
            this.gbLoaderService.hideLoaderDialog(CUSTOMER_PAYMENT_METHODS_LOADER.loadCustomerPaymentMethods.id),
          ),
        ),
      ),
    ),
  )

  showErrorToast$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(CustomerPaymentMethodsActions.loadCustomerPaymentMethodsFailure),
        map((action) => {
          if (!action.error) return
          const errorMessage = this.gbErrorMessageService.getErrorMessage(action.error['error'])
          if (errorMessage && typeof errorMessage === 'string') this.gbNotificationService.error(errorMessage)
          else {
            this.gbNotificationService.error('GENERIC.ERROR')
          }
        }),
      ),
    { dispatch: false },
  )

  openEventGuestPaymentMethodsDialog$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(CustomerPaymentMethodsActions.openPaymentMethodsDialog),
        exhaustMap((action) =>
          this.gbDashboardDialogService.getDialogObs(GbCustomerPaymentMethodsDialogComponent, {
            width: '500px',
            data: { profile: action.profile },
          }),
        ),
      ),
    { dispatch: false },
  )

  constructor(
    private customerPaymentMethodsApiService: CustomerPaymentMethodsApiService,
    private selectedAuctionFacade: SelectedAuctionFacade,
    private gbErrorMessageService: GbErrorMessageService,
    private gbNotificationService: GbNotificationService,
    private gbLoaderService: GbLoaderService,
    private gbDashboardDialogService: GbDashboardDialogService,
  ) {}
}
